import { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import PageTitle from "../../components/Elements/PageTitle/PageTitle.tsx";
import { useGet } from "../../components/Fetch/useFetch.tsx";
import { IconGaugeComponent } from "../../components/Icon/Icon.tsx";
import url from "../../module/fetch.tsx";
import {
  ComponentDashboard,
  DashboardComponentConfig,
  DashboardItemParam,
  normalizeComponentConfig,
} from "./Constants.tsx";
import DashboardItem from "./DashboardAdminDynamicConfig/DashboardItem.tsx";

const ComponentBoardList = () => {
  const [dashboardUser, setDashoardUser] =
    useState<DashboardItemParam | null>(); // Liste des onglets dashboard
  const [componentsListDashboard, setComponentsListDashboard] =
    useState<ComponentDashboard[]>(); // Composant sélectionner dans la grid

  const [numberRowGrid, setNumberRowGrid] = useState<number>(0);
  const heightRow = 200;

  // Récupère tous les composants en base liés au profil utilisateur
  const fetchDataDashboard = useGet(
    url`/api/dashboard/get-dashboard-user/`,
    {},
  );

  // Calcule le nombre de lignes nécessaires = bord bas du composant le plus bas
  const calculateRows = useCallback((componentList: ComponentDashboard[]) => {
    const maxBottom = componentList.reduce((acc, component) => {
      const bottom = component.configPosition
        ? component.configPosition.y + component.configPosition.hauteur
        : 0;
      return bottom > acc ? bottom : acc;
    }, 0);
    setNumberRowGrid(maxBottom);
  }, []);

  useEffect(() => {
    if (fetchDataDashboard.isResolved && fetchDataDashboard.data) {
      setDashoardUser({
        id: fetchDataDashboard.data?.dashboardId,
        title: fetchDataDashboard.data?.dashboardTitle,
      });
      const newComponentList: ComponentDashboard[] = [];
      fetchDataDashboard.data?.dashboardComponents?.forEach(
        (element: DashboardComponentConfig) => {
          // Set les composants à affiché dans la grille
          newComponentList.push({
            id: element.componentId,
            key: element.componentKey,
            title: element.componentTitle,
            config: normalizeComponentConfig(
              element.componentKey,
              element.componentConfig,
            ),
            configPosition: {
              x: element.componentConfigPosition
                ? element.componentConfigPosition.componentX
                : 0,
              y: element.componentConfigPosition
                ? element.componentConfigPosition.componentY
                : 0,
              largeur: element.componentConfigPosition
                ? element.componentConfigPosition.componentLargeur
                : 2,
              hauteur: element.componentConfigPosition
                ? element.componentConfigPosition.componentHauteur
                : 2,
            },
            queryId: element.componentQueryId,
          });
        },
      );
      if (newComponentList.length > 0) {
        calculateRows(newComponentList);
        setComponentsListDashboard(newComponentList);
      }
    }
  }, [fetchDataDashboard.data, fetchDataDashboard.isResolved, calculateRows]);

  // Si pas de dashboard on les récupère en base
  useEffect(() => {
    if (!dashboardUser && !fetchDataDashboard.isLoading) {
      fetchDataDashboard.run();
    }
  }, [dashboardUser, fetchDataDashboard]);

  return (
    <>
      {dashboardUser && dashboardUser.id ? (
        <Container fluid>
          <PageTitle
            icon={<IconGaugeComponent />}
            title={dashboardUser?.title}
          />
          {/* Grid Layout */}
          <Row
            className="position-relative"
            style={{ minHeight: `${numberRowGrid * heightRow}px` }}
          >
            {!componentsListDashboard && (
              <div className="alert alert-primary" role="alert">
                Ce dashboard n&apos;a aucun composant pour le moment.
              </div>
            )}
            {Array.from({ length: 4 }, (_, colIndex) => (
              <Col
                id="col-grid-component"
                key={colIndex}
                className="p-0 position-relative"
                style={{ height: "100%" }}
              >
                {Array.from({ length: numberRowGrid }, (_, rowIndex) => (
                  <div
                    key={`${colIndex}-${rowIndex}`}
                    id={`${colIndex}-${rowIndex}`}
                    className="droppable"
                    style={{
                      height: heightRow + "px", // Hauteur des lignes
                    }}
                  />
                ))}
              </Col>
            ))}

            {/* Components */}
            {componentsListDashboard &&
              componentsListDashboard.length > 0 &&
              componentsListDashboard.map((component) => (
                <DashboardItem
                  key={component.id}
                  component={component}
                  isSelected={false}
                  heightRow={heightRow}
                />
              ))}
          </Row>
        </Container>
      ) : (
        <div className="alert alert-primary" role="alert">
          Aucun dashboard n&apos;est disponible pour votre profil.
        </div>
      )}
    </>
  );
};

export default ComponentBoardList;
